import { render } from "./index.vue?vue&type=template&id=113f8658&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=113f8658&scoped=true&lang=css"
import "@vueform/slider/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113f8658"]])

export default __exports__